var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7157 26.0589L26.0588 31.7158L54.3431 60L26.0588 88.2843L31.7157 93.9411L57.1715 68.4853C58.7336 66.9232 61.2663 66.9232 62.8284 68.4853L88.2842 93.9411L93.9411 88.2843L65.6568 60L93.9411 31.7158L88.2842 26.0589L62.8284 51.5147C61.2663 53.0768 58.7336 53.0768 57.1715 51.5147L31.7157 26.0589Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXClose);
export default __webpack_public_path__ + "static/media/X_Close.ae32e23d.svg";
export { ForwardRef as ReactComponent };